import { isProposedDocument } from '../predicates'

import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import type { StoredDocument } from '@app/application/ai_ocr_requests/types'

export const useDocumentView = (
  document: Ref<StoredDocument>
): {
  viewingId: ComputedRef<string | number | undefined>
  viewingUrl: ComputedRef<string>
} => {
  const viewingId = computed<string | number | undefined>(() =>
    isProposedDocument(document.value)
      ? document.value.id
      : document.value.viewingId
  )

  const viewingUrl = computed(() => {
    if (!viewingId.value) {
      return ''
    }

    return window.Silverfin.Routes.document_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      viewingId.value.toString(),
      {
        current_ledger_id: window.Silverfin.currentLedgerId(),
      }
    )
  })

  return {
    viewingId,
    viewingUrl,
  }
}
